/**
 * The email field's own check, on submit only. Clerk checks the rest; these
 * are the mistakes worth catching before a round trip, each in words that
 * say what to fix.
 */
export const EMAIL_EMPTY = 'Enter your email address to continue.';
export const EMAIL_NO_AT = 'That address is missing an @.';
export const EMAIL_MALFORMED =
  'That doesn’t look like a full email address. Check the part after the @.';

/** Something before the @, and a dotted domain with a 2-letter ending. */
const FULL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;

export function emailProblem(raw: string): string | null {
  const email = raw.trim();
  if (!email) return EMAIL_EMPTY;
  if (!email.includes('@')) return EMAIL_NO_AT;
  if (!FULL.test(email)) return EMAIL_MALFORMED;
  return null;
}
